<template>
  <div class="page-wrap modify-feedback">
    <div class="form-info" v-if="studentInfo">
      <h1 class="title">{{ $t('report.confirmModificationFeedback') }}</h1>
      <a-row class="student-info">
        <a-col :span="8">
          {{ $t('public.name') }}{{ $t('public.colon')
          }}{{ studentInfo.name }}&nbsp;
          {{ studentInfo.surname }}
          {{ studentInfo.givenName }}({{ studentInfo.englishName }})
        </a-col>
        <a-col :span="8">
          {{ $t('public.studentId') }} {{ $t('public.colon') }}
          {{ studentInfo.studentNo }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.gender') }} {{ $t('public.colon') }}
          <a-icon
            v-if="!!studentInfo.gender"
            :style="{
              fontSize: '20px',
              color: $utils.filteGender(studentInfo.gender, 'color')
            }"
            :type="studentInfo.gender | filteGender('icon')"
          />
        </a-col>
        <a-col :span="8">
          {{ $t('public.dateOfBirth') }} {{ $t('public.colon') }}
          {{ studentInfo.birthdate }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.enrollmentTime') }} {{ $t('public.colon') }}
          {{ studentInfo.enrollDate }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.enrollmentGradeTitle') }} {{ $t('public.colon') }}
          {{ studentInfo.enrollGrade }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.currentGrade') }} {{ $t('public.colon') }}
          {{ studentInfo.currentGrade }}
        </a-col>
      </a-row>

      <div class="record" v-if="modifyStatus !== 'confirm'">
        <h2 class="record-title">
          {{ $t('report.currentFeedback') }}
        </h2>
        <a-row class="record-info">
          <a-col :span="12" class="record-item-title">
            {{ $t('public.comments') }}
          </a-col>
          <a-col :span="6" class="record-item-title">
            {{ $t('public.editor') }}
          </a-col>
          <a-col :span="6" class="record-item-title">
            {{ $t('public.submitTime') }}
          </a-col>
          <a-col :span="12" class="record-item-info">
            {{ currentRecord.comments }}
          </a-col>
          <a-col :span="6" class="record-item-info">
            {{ currentRecord.editor }}
          </a-col>
          <a-col :span="6" class="record-item-info">
            {{ currentRecord.createDate }}
          </a-col>
        </a-row>
      </div>

      <div class="record" v-if="modifyStatus !== 'turnDown'">
        <h2 class="record-title">
          {{
            modifyStatus === 'confirm'
              ? $t('report.currentFeedback')
              : $t('report.modifiedFeedback')
          }}
        </h2>
        <a-row class="record-info">
          <a-col :span="12" class="record-item-title">
            {{ $t('public.comments') }}
          </a-col>
          <a-col :span="6" class="record-item-title">
            {{ $t('public.editor') }}
          </a-col>
          <a-col :span="6" class="record-item-title">
            {{ $t('public.submitTime') }}
          </a-col>
          <a-col :span="12" class="record-item-info">
            {{ editorRecord.comments }}
          </a-col>
          <a-col :span="6" class="record-item-info">
            {{ editorRecord.editor }}
          </a-col>
          <a-col :span="6" class="record-item-info">
            {{ editorRecord.createDate }}
          </a-col>
        </a-row>
      </div>

      <div class="confirm-update" v-if="modifyStatus === ''">
        <a-button
          class="margin--right"
          :loading="loading"
          type="danger"
          @click="turnDown"
        >
          {{ $t('handle.turnDown') }}
        </a-button>
        <a-button :loading="loading" type="primary" @click="confirmUpdate">
          {{ $t('public.confirmModification') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modifyId: undefined,

      studentId: undefined,
      academic: undefined,
      term: undefined,

      studentInfo: null,
      currentRecord: {},
      editorRecord: {},

      loading: false,
      // 操作状态
      modifyStatus: ''
    }
  },

  created() {
    this.getParams()
  },

  methods: {
    // 参数
    getParams() {
      const query = this.$route.query
      this.studentId = query.studentId
      this.academic = query.academic
      this.term = query.term
      this.modifyId = query.id
      this.getUpdateInfo()
    },

    // 修改的信息
    getUpdateInfo() {
      this.$http(this.$api.GETFEEDBACKUPDATE, {
        studentId: this.studentId,
        academic: this.academic,
        term: this.term
      }).then(r => {
        if (r.data.feedback.length === 2) {
          this.studentInfo = r.data.student
          for (const item of r.data.feedback) {
            if (item.feedbackStatus === 5) {
              this.currentRecord = item
            } else {
              this.editorRecord = item
            }
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      })
    },

    // 确认修改
    confirmUpdate() {
      this.loading = true
      this.$http(this.$api.CONFIRMUPDATEFEEDBACK, {
        id: this.modifyId
      }).then(() => {
        this.modifyStatus = 'confirm'
        this.$message.success(this.$t('public.saveSuccess'))
      })
    },

    // 驳回修改
    turnDown() {
      this.loading = true
      this.$http(this.$api.TURNDOWNUPDATEFEEDBACK, {
        id: this.modifyId
      }).then(() => {
        this.modifyStatus = 'turnDown'
        this.$message.success(this.$t('public.turnDownSuccessfully'))
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.modify-feedback {
  .form-info {
    border: 1px solid @lineColor;
    padding: 20px 40px;
    width: 900px;
    margin: 50px auto 0;
    .title {
      font-size: 20px;
      text-align: center;
    }
    .student-info {
      margin-top: 20px;
      & > div {
        margin: 5px 0;
      }
    }
    .record,
    .record {
      margin-top: 30px;
    }
    .record-title {
      font-size: 16px;
    }
    .record-info {
      margin-top: 10px;
    }
    .record-item-title {
      background-color: @backColor;
      line-height: 2.5;
      padding: 0 10px;
    }
    .record-item-info {
      line-height: 2.5;
      padding: 0 10px;
    }
    .confirm-update {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
}
</style>
